export function formatPhoneNumber(phone: string): string {
  // Remove all non-digit characters
  const cleaned = ('' + phone).replace(/\D/g, '');
  // Match and format (201) 401 - 4031
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]} - ${match[3]}`;
  }
  return phone; // fallback to original if not 10 digits
}